import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {
	Box,
	Title,
	Text,
	Button,
	Table,
	Modal,
	TextInput,
	Select,
	Group,
} from '@mantine/core'
import { getOrgUsers, createOrgUser } from '../services/actions/userActions'

const ManageUsersPage = () => {
	const navigate = useNavigate()
	const [users, setUsers] = useState([])
	const [error, setError] = useState('')
	const [showModal, setShowModal] = useState(false)
	const [newUser, setNewUser] = useState({ name: '', email: '', role: 'user' })

	useEffect(() => {
		const fetchUsers = async () => {
			try {
				const data = await getOrgUsers()
				setUsers(data)
			} catch (err) {
				console.error('Failed to load users:', err)
				setError('Failed to load users.')
			}
		}

		fetchUsers()
	}, [])

	const handleCreateUser = async (e) => {
		e.preventDefault()
		try {
			await createOrgUser(newUser)
			setShowModal(false)
			setNewUser({ name: '', email: '', role: 'user' })
			const updatedUsers = await getOrgUsers()
			setUsers(updatedUsers)
		} catch (err) {
			console.error('Failed to create user:', err)
			setError('Failed to create user.')
		}
	}

	return (
		<Box px='md' py='md'>
			<Title order={2} mb='md'>
				Organization Users
			</Title>

			{error && (
				<Text color='red' mb='md'>
					{error}
				</Text>
			)}

			<Button onClick={() => setShowModal(true)} mb='lg'>
				➕ Create New User
			</Button>

			{users.length > 0 ? (
				<Table withBorder highlightOnHover striped>
					<thead>
						<tr>
							<th>Name</th>
							<th>Email</th>
							<th>Role</th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						{users.map((user) => (
							<tr key={user.id}>
								<td>{user.name}</td>
								<td>{user.email}</td>
								<td>
									{user.role === 'admin'
										? 'Admin'
										: user.role === 'user'
										? 'User'
										: user.role}
								</td>
								<td style={{ textAlign: 'right' }}>
									<Button
										size='xs'
										variant='light'
										onClick={() => navigate(`/admin/users/${user.id}/edit`)}
									>
										Edit
									</Button>
								</td>
							</tr>
						))}
					</tbody>
				</Table>
			) : (
				<Text>No users found.</Text>
			)}

			<Modal
				opened={showModal}
				onClose={() => setShowModal(false)}
				title='Create New User'
				centered
			>
				<form onSubmit={handleCreateUser}>
					<TextInput
						label='Name'
						value={newUser.name}
						onChange={(e) => setNewUser({ ...newUser, name: e.target.value })}
						required
						mb='sm'
					/>
					<TextInput
						label='Email'
						type='email'
						value={newUser.email}
						onChange={(e) => setNewUser({ ...newUser, email: e.target.value })}
						required
						mb='sm'
					/>
					<Select
						label='Role'
						value={newUser.role}
						onChange={(value) => setNewUser({ ...newUser, role: value })}
						data={[
							{ value: 'user', label: 'User' },
							{ value: 'admin', label: 'Admin' },
						]}
						required
					/>
					<Group mt='lg' position='right'>
						<Button variant='light' onClick={() => setShowModal(false)}>
							Cancel
						</Button>
						<Button type='submit'>Save</Button>
					</Group>
				</form>
			</Modal>
		</Box>
	)
}

export default ManageUsersPage
